import {
  Directive,
  Input,
  ElementRef,
} from '@angular/core';

@Directive({
    selector: '[appAnimation]',
    standalone: false
})
export class AnimationDirective {
  animationCssClass: string;
  animationCssClassRevert?: string;
  private _runAnimation = false;
  private _runAnimationRevert = false;
  private _animationDisabled = true;

  @Input() set appAnimation(cssClass: string) {
    this.animationCssClass = cssClass;
  }

  @Input() set appAnimationIf(condition: number) {
    if (condition === 0) {
      this.el.nativeElement.classList.remove(this.animationCssClass);
      return;
    }
    // from https://css-tricks.com/restart-css-animation/
    this.el.nativeElement.classList.remove(this.animationCssClass);
    this.el.nativeElement.classList.add(this.animationCssClass);
  }

  @Input() set appAnimationIfBool(condition: boolean) {
    if (this._animationDisabled) {
      return;
    }

    // 1. cssClass
    if (!condition) {
      this.el.nativeElement.classList.remove(this.animationCssClass);
      this._runAnimation = false;
    } else {

      // from https://css-tricks.com/restart-css-animation/
      if (!(this.canRunAnimation() && condition)) {

        this._runAnimation = true;
        this.el.nativeElement.classList.remove(this.animationCssClass);
        this.el.nativeElement.classList.add(this.animationCssClass);
      }
    }


    // 2. cssClassRevert
    if (condition) {
      this.el.nativeElement.classList.remove(this.animationCssClassRevert);
      this._runAnimationRevert = false;
    } else {

      // from https://css-tricks.com/restart-css-animation/
      if (!(this.canRunAnimation() && !condition)) {

        this._runAnimationRevert = true;
        this.el.nativeElement.classList.remove(this.animationCssClassRevert);
        this.el.nativeElement.classList.add(this.animationCssClassRevert);
      }
    }
  }

  @Input() set appAnimationRevert(cssClassRevert: string) {
    this.animationCssClassRevert = cssClassRevert;
  }

  @Input() set appAnimationDisabled(disabled: boolean) {
    this._animationDisabled = disabled;
  }

  constructor(private el: ElementRef) { }

  private canRunAnimation() {
    return this._runAnimation;
  }

  private canRunAnimationRevert() {
    return this._runAnimationRevert;
  }

}
